import { IllustName } from '@/shared/ui'

export const REVIEW_ILLUST_MAP: Record<string, IllustName> = {
  FAST_RESPONSE: 'quickResponse',
  KIND_HOST: 'kindHost',
  CONVENIENT_TRANSPORT: 'easyTransit',
  NEAR_AMENITIES: 'manyAmenities',
  GOOD_PRICE: 'goodPrice',
  CLEAN_INTERIOR: 'cleanInterior',
  GOOD_INTERIOR: 'niceInterior',
  GOOD_MOOD: 'goodNeighborhood',
}
